export const approvalRoles = ['지사', '총판', '대리점', '영업자1', '영업자2', '영업자3'];
export const approvalNumber = value => value !== null && value !== undefined && String(value).trim() !== '' && Number.isFinite(Number(value)) ? Number(value) : null;
export const approvalMoney = value => approvalNumber(value) === null ? '—' : `${Number(value).toLocaleString('ko-KR')}원`;
export const approvalRate = value => approvalNumber(value) === null ? '—' : `${Number(value).toFixed(2)}%`;
export const approvalStatus = row => ({'1':'승인','2':'취소','3':'매입 후 취소'}[String(row.state)] || '확인 필요');
export function allowedApprovalRoles(level) {
    const n = approvalNumber(level);
    return n !== null && Number.isInteger(n) && n >= 1 && n <= 6
        ? approvalRoles.map((label, i) => ({label, level:i+1})).filter(role => n <= role.level) : [];
}
export function approvalFees(row, level) {
    let items = row.up_data;
    try { if (typeof items === 'string') items = JSON.parse(items); } catch { items = []; }
    if (!Array.isArray(items)) items = [];
    // Preserve the existing API's reverse hierarchy ordering and supplied rate.
    return allowedApprovalRoles(level).map(role => {
        const item = items[items.length - role.level];
        return {...role, amount:approvalNumber(item?.fee_amt) === null ? null : Math.round(Number(item.fee_amt)), rate:item?.fee};
    });
}
